import * as React from 'react';

export const Menu = React.lazy(() => import('./Menu'));
